import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import { Autocomplete, Checkbox, Chip, CircularProgress, MenuItem, TextField } from '@mui/material';
import React from 'react';
import { Control, Controller, UseFormWatch, useController } from 'react-hook-form';
import { ExerciseFormData } from '../../create-exercise/scheduled/CreateExerciseDialog';
import { ExerciseFile, TechnologyPlatform } from '../../types';

export interface ExercisesTagsFieldProps {
  control: Control<any>;
  disabled: boolean;
  exercises?: ExerciseFile[] | null;
  loading: boolean;
  name: string;
  platform?: string | number;
  watch: UseFormWatch<ExerciseFormData>;
}

export default function ExercisesTagsField({
  control,
  disabled,
  exercises,
  loading,
  name,
  platform,
  watch,
}: ExercisesTagsFieldProps) {
  const [exercisesMetaData] = watch(['exercisesMetaData']);

  useController({
    control,
    name,
    rules: {
      required: 'Please select an exercise',
    },
  });

  const getOptionLabel = optionId => exercises?.find(e => e.id === optionId)?.title ?? '';

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, ...field }, fieldState: { error } }) => {
        return (
          <Autocomplete
            data-cy={`select-exercise`}
            {...field}
            disabled={disabled}
            multiple
            clearOnBlur
            disablePortal={false}
            getOptionLabel={getOptionLabel}
            handleHomeEndKeys
            isOptionEqualToValue={(option, value) => option === value}
            renderTags={(tagValue, getTagProps) => {
              const tags = tagValue.map((id, index) => (
                <Chip
                  label={getOptionLabel(id)}
                  {...getTagProps({ index })}
                  key={index}
                  color={
                    //TODO refactor
                    platform === TechnologyPlatform.Spirit &&
                    exercisesMetaData?.find(
                      el =>
                        el?.id === id &&
                        (!el?.metaData.length ||
                          (field.value.length > 1 &&
                            (el?.metaData.length !== 1 || el?.metaData[0].students.length !== 1))),
                    )
                      ? 'error'
                      : 'default'
                  }
                />
              ));

              return (
                <>
                  {loading && <CircularProgress color="inherit" size={20} />}
                  {tags}
                </>
              );
            }}
            id="days-autocomplete"
            value={field.value || []}
            onChange={(event, value) => field.onChange(value)}
            options={(exercises ?? []).map(e => e?.id)}
            renderOption={(props, optionId, { selected }) => (
              <MenuItem {...props} key={optionId}>
                <Checkbox
                  icon={<CheckBoxOutlineBlank fontSize="small" />}
                  checkedIcon={<CheckBox fontSize="small" />}
                  sx={{ p: 0, paddingRight: 1 }}
                  checked={selected}
                />
                {getOptionLabel(optionId)}
              </MenuItem>
            )}
            renderInput={params => (
              <TextField
                required
                error={!!error}
                helperText={error?.message}
                label="Simulator exercises"
                name={name}
                type="search"
                inputRef={ref}
                {...params}
              />
            )}
          />
        );
      }}
    />
  );
}
